// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactModal from "react-modal";
import * as MediaQuery$PorterinUtils from "../../../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as BookingDetailsModuleScss from "../styles/BookingDetails.module.scss";
import * as EditBookingDetailsMobileWrapperCmp$PorterinFeature from "../../modals/EditBookingDetailsMobileWrapperCmp.mjs";
import * as EditBookingDetailsDesktopWrapperCmp$PorterinFeature from "../../modals/EditBookingDetailsDesktopWrapperCmp.mjs";

var styles = BookingDetailsModuleScss;

function BookingDetailsModal(Props) {
  var modal_state = Props.modal_state;
  var close_modal = Props.close_modal;
  var waypoint = Props.waypoint;
  var is_address_modal_openOpt = Props.is_address_modal_open;
  var is_address_modal_open = is_address_modal_openOpt !== undefined ? is_address_modal_openOpt : false;
  return React.createElement(ReactModal, {
              isOpen: modal_state,
              onRequestClose: close_modal,
              closeTimeoutMS: 0,
              overlayClassName: styles.overlay,
              className: "" + styles["modal-container"] + "",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: MediaQuery$PorterinUtils.isWideDesktop(undefined) ? React.createElement(EditBookingDetailsDesktopWrapperCmp$PorterinFeature.make, {
                      close_modal: close_modal,
                      waypoint: waypoint
                    }) : React.createElement(EditBookingDetailsMobileWrapperCmp$PorterinFeature.make, {
                      close_modal: close_modal,
                      waypoint: waypoint,
                      is_address_modal_open: is_address_modal_open
                    })
            });
}

var make = BookingDetailsModal;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
